import { render, staticRenderFns } from "./SpotifyAds.vue?vue&type=template&id=21ebf520&scoped=true&"
import script from "./SpotifyAds.vue?vue&type=script&lang=js&"
export * from "./SpotifyAds.vue?vue&type=script&lang=js&"
import style0 from "./SpotifyAds.vue?vue&type=style&index=0&id=21ebf520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ebf520",
  null
  
)

export default component.exports